import { render } from "./TagTemplate.vue?vue&type=template&id=5693ea1b"
import script from "./TagTemplate.vue?vue&type=script&lang=js"
export * from "./TagTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__